// extracted by mini-css-extract-plugin
export default {"button":"indicador_button__v5Kuz","filtro":"indicador_filtro__o+04F"};